<template>
  <div id="loqate_address_form">
    <div class="form-group" :id="loqate_container_id">
      <input
        :id="loqate_search_id"
        type="search"
        class="form-control bg-light"
        :name="loqate_search_name"
        placeholder="Search by postcode or typing part of the address."
        autocomplete="none"
        v-show="!loading"
      />
    </div>

    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>

    <div
      v-if="loading"
      class="d-flex align-items-center text-center justify-content-center"
    >
      <div class="spinner-border" role="status" aria-hidden="true"></div>
    </div>

    <p :class="showAddressFields ? 'd-none' : ''">Enter your postcode to find your address, or <a href="#" @click="toggleAddressFields(true)">click here</a> to enter manually.</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      countries: null,
      error: false,
      loqate_container_id: null,
      loqate_search_id: null,
      loqate_search_name: null,
      showAddressFields: this.edit,
    };
  },

  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    addressId: {
      type: [String, Number],
      default: null
    },
    selectedCountry: {
      type: String,
      default: null
    }
  },

  watch: {
      selectedCountry(newVal) {
          this.locateAddress(newVal);
      }
  },

  mounted() {
      this.locateAddress();
      this.toggleAddressFields(this.showAddressFields);
  },
  methods: {
    locateAddress(selectedCountry) {
        // Add the postcodeanywhere styles
        this.loadStylesheet();

        this.loqate_container_id = Math.random().toString(36).slice(2);
        this.loqate_search_id = Math.random().toString(36).slice(2);
        this.loqate_search_name = Math.random().toString(36).slice(2);

        let loqateApi = document.createElement("script");
        let url = '/api/v1/countries';

        if (this.addressId) {
            url += `?address=${this.addressId}`;
        }

        loqateApi.onload = () => {
            if (selectedCountry) {
                this.initLoqate(selectedCountry);
            } else {
                axios
                    .get(url)
                    .then((res) => {
                        if (res.data && res.data.success) {
                            this.countries = res.data.countries;
                            var countriesKeyArr = Object.keys(this.countries);
                            var searchCountries = countriesKeyArr.join();
                            this.initLoqate(searchCountries);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally((res) => {
                        this.loading = false;
                    });
            }
        };
        loqateApi.setAttribute(
            "src",
            "//services.postcodeanywhere.co.uk/js/address-3.91.min.js"
        );
        document.head.appendChild(loqateApi);
    },
    loadStylesheet() {
      const stylesheetUrl = "//services.postcodeanywhere.co.uk/css/address-3.91.min.css";

      // Check if the stylesheet is already loaded
      if (!document.querySelector(`link[href="${stylesheetUrl}"]`)) {
        // Create a <link> element
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = stylesheetUrl;

        // Append the <link> element to the <head>
        document.head.appendChild(link);
      }
    },

    toggleAddressFields(show) {
      this.showAddressFields = show;

      const elements = document.querySelectorAll(`[name=${this.prefix}company_name], [name=${this.prefix}address_1], [name=${this.prefix}address_2], [name=${this.prefix}city], [name=${this.prefix}county], [name=${this.prefix}postcode], [name=${this.prefix}country_iso2]`);

      elements.forEach(el => {
        if(show) {
          el.parentElement.classList.remove('d-none');
        } else {
          el.parentElement.classList.add('d-none');
        }
      })
    },

    initLoqate(searchCountries) {
      const loqateAddressFields = [
        { element: this.loqate_search_name, field: "" },
        {
          element: this.prefix + "company_name",
          field: "Company",
          mode: pca.fieldMode.DEFAULT | pca.fieldMode.PRESERVE,
        },
        { element: this.prefix + "address_1", field: "Line1", mode: pca.fieldMode.POPULATE },
        { element: this.prefix + "address_2", field: "Line2", mode: pca.fieldMode.POPULATE },
        { element: this.prefix + "city", field: "City", mode: pca.fieldMode.POPULATE },
        { element: this.prefix + "county", field: "Province", mode: pca.fieldMode.POPULATE },
        {
          element: this.prefix + "postcode",
          field: "PostalCode",
          mode: pca.fieldMode.POPULATE,
        },
        {
          element: this.prefix + "country_iso2",
          field: "CountryName",
          mode: pca.fieldMode.COUNTRY,
        },
      ];

      const loqateOptions = {
        key: process.env.MIX_LOQATE_API,
        search: { countries: searchCountries },
        manualEntryItem: true,
        suppressAutocomplete: true,
        setCountryByIP: !this.edit,
      };

      const loqateAddressControl = new pca.Address(
        loqateAddressFields,
        loqateOptions
      );

      loqateAddressControl.listen("manual", (address, variations) => {
        this.toggleAddressFields(true);
        document.getElementById(this.loqate_container_id).style.display = 'none';
      });

      loqateAddressControl.listen("populate", (address, variations) => {
        this.toggleAddressFields(true);
        document.querySelectorAll(`[name=${this.prefix}company_name], [name=${this.prefix}address_1], [name=${this.prefix}address_2], [name=${this.prefix}city], [name=${this.prefix}county], [name=${this.prefix}postcode], [name=${this.prefix}country_iso2]`).forEach(el => {
          el.dispatchEvent(new Event('input')); // So Vue knows it has changed if used in models.
        })
      });
    },
  },
};
</script>
